import ReallocationSuggestions from '@/components/fulfillment_orders/ReallocationSuggestions'

export default function ReallocationPage() {
    return <ReallocationSuggestions />
}
